import { render, staticRenderFns } from "./Embeds.vue?vue&type=template&id=177bc7ad&scoped=true"
import script from "./Embeds.vue?vue&type=script&lang=js"
export * from "./Embeds.vue?vue&type=script&lang=js"
import style0 from "./Embeds.vue?vue&type=style&index=0&id=177bc7ad&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177bc7ad",
  null
  
)

export default component.exports